import React from 'react';
import { Link } from 'react-router-dom';
import { Listing } from '../types';

interface ListingCardProps {
  listing: Listing;
}

const ListingCard: React.FC<ListingCardProps> = ({ listing }) => {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(price);
  };

  const formatBaths = (baths: number) => {
    if (baths % 1 === 0) return baths;
    return baths.toFixed(1);
  };

  // Generate URL-friendly slug from address
  const addressSlug = listing.address
    .replace(/[^a-zA-Z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();

  // Build the listing URL with idxID, listingID, and address slug
  const listingUrl = listing.idxID
    ? `/listings/${listing.idxID}/${listing.id}/${addressSlug}`
    : `/listings/${listing.id}`;

  // Get display text for non-active statuses (case-insensitive)
  const getStatusBadge = () => {
    const statusLower = listing.status.toLowerCase();
    if (statusLower === 'active') return null;
    if (statusLower === 'sold') return 'Sold';
    if (statusLower === 'pending') {
      // Check propStatus for more specific display text
      const propStatusLower = listing.propStatus?.toLowerCase();
      if (propStatusLower === 'contingent') return 'Contingent';
      return 'Pending';
    }
    // For any other non-active status, display it with title case
    return listing.status.charAt(0).toUpperCase() + listing.status.slice(1).toLowerCase();
  };

  const statusBadge = getStatusBadge();

  return (
    <Link to={listingUrl} className="card listing-card" style={{ textDecoration: 'none', color: 'inherit' }}>
      <div style={{ position: 'relative' }}>
        <img src={listing.image} alt={listing.address} className="card-image" />
        {statusBadge && (
          <span className="listing-badge">{statusBadge}</span>
        )}
      </div>
      <div className="card-content">
        <p className="listing-price">{formatPrice(listing.price)}</p>
        <p className="listing-address">
          {listing.address}<br />
          {listing.city}, {listing.state} {listing.zip}
        </p>
        <div className="listing-details">
          <span>
            <span className="material-icons" style={{ fontSize: '1rem' }}>bed</span>
            {listing.beds} Beds
          </span>
          <span>
            <span className="material-icons" style={{ fontSize: '1rem' }}>bathtub</span>
            {formatBaths(listing.baths)} Baths
          </span>
          <span>
            <span className="material-icons" style={{ fontSize: '1rem' }}>square_foot</span>
            {listing.sqft.toLocaleString()} Sq Ft
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ListingCard;
